export const GET_ALL_GAMES= "GET_ALL_GAMES"
export const GET_VIDEOGAME_NAME= "GET_VIDEOGAME_NAME"
export const GET_VIDEOGAME_DETAIL="GET_VIDEOGAME_DETAIL"
export const FILTER_BY_NAME= "FILTER_BY_ID"
export const FILTER_BY_GENRES= "FILTER_BY_GENRES"
export const ALL_GAMES_BACKUP= "ALL_GAMES_BACKUP"
export const FILTER_BY_PLATFORM= "FILTER_BY_PLATFORM"
export const RESET= "RESET"
export const CHANGE_NEXT_PAGE = "CHANGE_NEXT_PAGE"
export const CHANGE_BACK_PAGE = "CHANGE_BACK_PAGE"
export const CHANGE_PAGE = "CHANGE_PAGE"
export const SET_PAGE_STATE= "SET_PAGE_STATE"
export const SORT_BY_NAMEAZ= "SORT_BY_NAMEAZ"
export const RESET_DETAILS= "RESET_DETAILS"
export const CLEAR_NAME_DETAIL= "CLEAR_NAME_DETAIL"
export const SORT_BY_RATING15= "SORT_BY_RATING15"
export const SORT_BY_RATING51= "SORT_BY_RATING51"
export const NEED_BACKUP="NEED_BACKUP"
export const PRE_FILTER="PRE_FILTER"
export const NOT_FOUND= "NOT_FOUND"